<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaSolicitacao />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>

<script>
import ListaSolicitacao from "../Components/Listagens/ListaSolicitacao.vue";
export default {
  name: "ListPromoter",
  components: {
    ListaSolicitacao,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>